<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard #wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}"
                         icon="basicSettings" [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3>{{(screenHardwareID ? 'lang.devices.editScreenHardware' : 'lang.devices.createScreenHardware') | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="row mt-5">
                    <div class="col-md-8">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Name">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                        <input type="text" id="Name" class="form-control" formControlName="Name" sbAutofocus>
                        <div *ngIf="Name.touched && Name.errors?.required" class="alert alert-danger">
                          {{'lang.globals.nameWarning' | translate}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
                        <input type="text" id="Description" class="form-control" formControlName="Description">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-5">
                    <div class="col-md-8">
                      <label class="form-label" for="Manufacturer">{{'lang.devices.editDeviceHardware.manufacturer' | translate}}</label>
                      <sb-comp-dropdown-select
                        id="Manufacturer"
                        class="mt-5"
                        *ngPermissions="[permissionService.Permission.company_list]"
                        [singleSelectMode]="true" [showSubmit]="false"
                        [inputData]="manufacturers" [dropDownDatatype]="'COMPANIES'" [useNoSelectionLabel]="true"
                        (selectedDataEmitter)="update($event, 'COMPANIES')" [showColumnIcon]="false"
                        [msOptions]="msManufacturersOptions" (msOptionsChange)="msRequest('COMPANIES', $event)"
                        [selectedInputData]="screenHardware?.manufacturer ? [screenHardware?.manufacturer] : []">
                      </sb-comp-dropdown-select>
                    </div>
                  </div>
                  <div class="row mt-5">
                    <div class="col-md-8">
                      <label class="form-label" for="PlayerHardware">{{'lang.globals.playerHardware' | translate}}</label>
                      <sb-comp-dropdown-select
                        id="PlayerHardware"
                        class="mt-5"
                        *ngPermissions="[permissionService.Permission.player_hardware_list]"
                        [singleSelectMode]="true" [showSubmit]="false"
                        [inputData]="playerHardwareList" [dropDownDatatype]="'PLAYER_HARDWARE'"
                        [useNoSelectionLabel]="true"
                        (selectedDataEmitter)="update($event, 'PLAYER_HARDWARE')" [showColumnIcon]="false"
                        [msOptions]="msPlayerHardwareOptions" (msOptionsChange)="msRequest('PLAYER_HARDWARE', $event)"
                        [selectedInputData]="screenHardware?.mountedTo ? [screenHardware?.mountedTo] : []">
                      </sb-comp-dropdown-select>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="row">
                    <h5>{{ 'lang.globals.resolution' | translate }}</h5>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-3">
                      <div class="form-group validateMe">
                        <label class="form-label" for="DisplayWidth">{{'lang.devices.editScreenHardware.displayWidth' | translate}}</label>
                        <input type="number" id="DisplayWidth" class="form-control" formControlName="DisplayWidth"
                               (ngModelChange)="calculateAspectRatio()">
                        <div *ngIf="DisplayWidth.touched && DisplayWidth.errors?.required" class="alert alert-danger">
                          {{'lang.devices.editScreenHardware.widthWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-1 d-flex justify-content-center align-items-center w-auto">
                      x
                    </div>
                    <div class="col-md-3">
                      <div class="form-group validateMe">
                        <label class="form-label"
                               for="DisplayHeight">{{'lang.devices.editScreenHardware.displayHeight' | translate}}</label>
                        <input type="number" id="DisplayHeight" class="form-control" formControlName="DisplayHeight"
                               (ngModelChange)="calculateAspectRatio()">
                        <div *ngIf="DisplayHeight.touched && DisplayHeight.errors?.required" class="alert alert-danger">
                          {{'lang.devices.editScreenHardware.heightWarning' | translate}}</div>
                      </div>
                    </div>
                    <div *ngIf="aspectRatio" class="col font-weight-bold d-flex align-items-center"
                         style="opacity: 0.6; font-size:16px;">{{aspectRatio}} {{ 'lang.globals.aspectRatio' | translate}}
                    </div>
                  </div>
                  <div class="row">
                    <h5>{{ 'lang.globals.dimensions' | translate }}</h5>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-4">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Diagonal">{{'lang.devices.editScreenHardware.diagonal' | translate}}</label>
                        <input type="number" id="Diagonal" class="form-control" formControlName="Diagonal">
                        <div *ngIf="Diagonal.touched && Diagonal.errors?.required" class="alert alert-danger">
                          {{'lang.devices.editScreenHardware.diagonalWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Width">{{'lang.devices.editScreenHardware.width' | translate}}</label>
                        <input type="number" id="Width" class="form-control" formControlName="Width"
                               (ngModelChange)="checkWidthAndHeightInputs()">
                        <div *ngIf="Width.touched && Width.errors?.required" class="alert alert-danger">
                          {{'lang.devices.editScreenHardware.widthWarning' | translate}}</div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Height">{{'lang.devices.editScreenHardware.height' | translate}}</label>
                        <input type="number" id="Height" class="form-control" formControlName="Height"
                               (ngModelChange)="checkWidthAndHeightInputs()">
                        <div *ngIf="Height.touched && Height.errors?.required"
                             class="alert alert-danger">
                          {{'lang.devices.editScreenHardware.heightWarning' | translate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.playerHardware)"
                           type="button" class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}
                </button>
                <button type="button" (click)="updateScreenHardware()" [disabled]="!form.valid || loading"
                           class="btn btn-success btn-wide btn-lg">
                  {{(screenHardwareID ? 'lang.globals.save' : 'lang.globals.submit') | translate}}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
